import router from '@/router'
import axios from 'axios'
import { ActionContext } from 'vuex'
import {
	AuthState,
	LoginData,
	RootModule,
	SignUpData,
	User,
	BeginPasswordReset,
	EndPasswordReset,
} from '@/store/types'
import { showErrorSnackBar } from '@/utils'

const user = JSON.parse(localStorage.getItem('user') as string)
const initialState = user
	? {
		status: { loggedIn: true },
		user,
		loginError: false,
		signUpError: false,
		isMB: user.data?.isMediaBuying,
	}
	: {
		status: { loggedIn: false },
		user: null,
		loginError: false,
		signUpError: false,
		isMB: false,
	}

const authModule = {
	namespaced: true,
	state: initialState,
	actions: {
		async login(
			{ commit }: ActionContext<AuthState, RootModule>,
			{ email, password }: LoginData,
		) {
			try {
				const { data } = await axios.post('/api/auth/login', {
					email,
					password,
				})
				const config = {
					headers: { Authorization: `Bearer ${data.accessToken}` },
				}
				const user = (await axios.get('api/auth/profile', config)).data
				commit('loginSuccess', { ...user, ...data, email })
				if (user.data.isApproved) {
					await router.push('/dashboard')
				} else {
					await router.push('/waiting')
				}
			} catch (err) {
				showErrorSnackBar(err as any)
				commit('loginFailure')
				throw err
			}
		},
		async startPasswordReset(
			{ commit }: ActionContext<AuthState, RootModule>,
			{ email }: BeginPasswordReset,
		) {
			try {
				await axios.post('/api/auth/reset-password', { email })
				commit('passwordResetSuccess')
			} catch (err) {
				showErrorSnackBar(err as any)
				commit('passwordResetFailure')
				throw err
			}
		},
		async finishPasswordReset(
			{ commit }: ActionContext<AuthState, RootModule>,
			{ key, newPassword }: EndPasswordReset,
		) {
			try {
				await axios.put('/api/auth/reset-password', { newPassword, key })
				commit('passwordResetSuccess')
				await router.push('/login')
			} catch (err) {
				showErrorSnackBar(err as any)
				commit('passwordResetFailure')
			}
		},
		async tryImpersonate({ commit }: ActionContext<AuthState, RootModule>) {
			const urlParams = new URLSearchParams(location.search)
			const key = urlParams.get('key')
			if (!key) {
				return
			}
			const { data } = await axios.post('/api/auth/impersonate', { key })
			const config = {
				headers: { Authorization: `Bearer ${data.accessToken}` },
			}
			const user = (await axios.get('api/auth/profile', config)).data
			commit('loginSuccess', { ...user, ...data })
			if (user.data.isApproved) {
				await router.push('/dashboard')
			} else {
				await router.push('/waiting')
			}
		},
		async signUp(
			{ commit }: ActionContext<AuthState, RootModule>,
			{ email, password, telegram, ref }: SignUpData,
		) {
			try {
				await axios.post(
					'/api/auth/sign-up',
					{
						email,
						password,
						telegram,
						ref,
					},
					{ params: { ...router.currentRoute.value.query } },
				)
			} catch (err) {
				showErrorSnackBar(err as any)
				commit('signUpFailure')
				throw err
			}
		},
		async logout({ commit }: ActionContext<AuthState, RootModule>) {
			await axios.post('/api/auth/logout')
			commit('logout')
		},
		async checkIsApproved({ commit }: ActionContext<AuthState, RootModule>) {
			const aff = (await axios.get('/api/profile')).data
			// aff.isApproved = true
			// aff.isMediaBuying = true

			if (aff.isApproved) {
				const user = { data: aff, email: aff.credentials?.email }
				commit('loginSuccess', user)
				await router.push('/dashboard')
			}
		},
	},
	mutations: {
		loginSuccess(state: AuthState, user: User) {
			state.status = { loggedIn: true }
			state.user = user
			state.loginError = false
			state.signUpError = false
			localStorage.setItem('user', JSON.stringify(user))
			state.isMB = (user as any).data?.isMediaBuying
		},
		loginFailure(state: AuthState) {
			state.status = { loggedIn: false }
			state.user = null
			state.loginError = true
		},
		signUpFailure(state: AuthState) {
			state.signUpError = true
		},
		passwordResetSuccess(state: AuthState) {
			state.passwordResetError = false
		},
		passwordResetFailure(state: AuthState) {
			state.passwordResetError = true
		},
		logout(state: AuthState) {
			state.status = { loggedIn: false }
			state.isMB = false
			state.user = null
			localStorage.removeItem('user')
			window.location.replace('/')
		},
		resetErrors(state: AuthState) {
			state.loginError = false
			state.signUpError = false
			state.passwordResetError = false
		},
	},
}

export default authModule
